module.exports = __webpack_public_path__ + "img/pr-5.57a3aacc.png";